import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Navbar";
import AddPost from "../../components/Posts/AddPost";

function AddPostPage() {
  return (
    <div>
      <Header />
      <AddPost />
      <Footer />
    </div>
  );
}

export default AddPostPage;
